<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    درباره ما
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="card card-style text-center mb-3">
                <div class="content pb-2">
                    <h3 class="font-700 mt-4 line-height-xl font-16">
                        <span v-if="isKarnegasht==true">کارنگاشت | اپلیکیشن گزارش کار روزانه</span>
                        <span v-if="isKarnegasht==false">تسکینو | اپلیکیشن برنامه ریزی و مدیریت کارها</span>

                    </h3>
                    <p class="font-12 mt-2 color-highlight mb-3">نسخه شماره {{appVersionCode}}</p>
                    <div v-if="isFreeVersion==true" class="text-center brand-color font-10" style="margin-top:-4px"> Free Installation </div>
                </div>
            </div>


            <div class="card card-style text-center mb-3" v-if="isMinVersion==false && info!=null">
                <div class="content pb-2">
                    <div>
                        <i class="far fa-user-circle color-blue1-dark fa-3x pt-3 icon-size"></i>
                    </div>
                    <h3 class="font-700 mt-4 line-height-xl">{{info.title}}</h3>
                    <p class="boxed-text-l mt-2 mb-2">
                        شمار ه تماس : {{ info.phoneNumber}}
                    </p>

                </div>
            </div>





            <div class="card card-style">
                <div v-if="isKarnegasht==false" class="d-flex justify-content-center">
                    <a v-if="isFreeVersion==false" href='https://taskinoapp.com/' class="text-center mt-4" target="_blank">
                        <img class="rounded-circle" src="/assets/images/taskinoIcon-02.png" alt="taskinologo" width="128" height="128" />
                    </a>
                    <a v-else class="text-center mt-4">
                        <img class="rounded-circle" src="/assets/images/taskinoIcon-02.png" alt="taskinologo" width="128" height="128" />
                    </a>
                </div>
                <div v-if="isKarnegasht==true" class="d-flex justify-content-center">
                    <a v-if="isFreeVersion==false" href='https://karnegasht.com/' class="text-center mt-4" target="_blank">
                        <img class="rounded-circle" src="/assets/images/karnegasht-logo-02.png" alt="karnegashtlogo" width="128" height="128" />
                    </a>
                    <a v-else class="text-center mt-4">
                        <img class="rounded-circle" src="/assets/images/karnegasht-logo-02.png" alt="karnegashtlogo" width="128" height="128" />
                    </a>
                </div>



                <p class="boxed-text-l mt-2 mb-2">
                    تهران، خیابان سهروردی شمالی، خیابان میرزای زینالی شرقی، پلاک 61، واحد 7
                </p>
                <div v-if="isKarnegasht==false" class="d-flex justify-content-center">
                    <a v-if="isFreeVersion==false" target="_blank" :href="aboutUrl" class="text-center mt-2 font-weight-bold">
                        taskinoapp.com
                    </a>
                    <a v-else class="text-center mt-2 font-weight-bold">
                        taskinoapp.com
                    </a>
                </div>
                <div v-if="isKarnegasht==true" class="d-flex justify-content-center">
                    <a v-if="isFreeVersion==false" target="_blank" :href="aboutUrl" class="text-center mt-2 font-weight-bold">
                        karnegasht.com
                    </a>
                    <a v-else class="text-center mt-2 font-weight-bold">
                        karnegasht.com
                    </a>
                </div>
                
                <div v-if="isKarnegasht==false">
                    <p class="font-12 mt-3 text-center" v-if="isMinVersion==true && isFreeVersion==false">
                        جهت استفاده از نسخه دسکتاپ به نشانی اینترنتی زیر مراجعه نمایید
                        <span class="ltr d-inline-block">https://taskinoapp.com/</span>                        
                    </p>
                </div>
                <div v-if="isKarnegasht==true">
                    <p class="font-12 mt-3 text-center" v-if="isMinVersion==true && isFreeVersion==false">
                        جهت استفاده از نسخه دسکتاپ به نشانی اینترنتی زیر مراجعه نمایید
                        <sppn class="ltr d-inline-block">https://karnegasht.com/</sppn>                        
                    </p>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    export default {
        data() {
            return {
                aboutUrl: "",
                info: null
            }
        },
        methods: {
            GetCompanyItem() {
                this.$http.get("Person/GetLocalCompany")
                    .then(data => {
                        this.info = data.data;
                    });
            },
            GetAboutLinkUrl() {
                this.$http.get("Task/GetAboutLinkUrl")
                    .then(data => {
                        this.aboutUrl = data.data;
                    });
            },
        },
        created() {
            this.GetCompanyItem();
            this.GetAboutLinkUrl();
        }
    }
</script>